import { renderRow } from './rows'
import { type SearchPage } from './search'

export type SearchResultsElements = {
  list?: HTMLElement
  loading?: HTMLElement
  error?: HTMLElement
  empty?: HTMLElement
  rowTemplate?: HTMLTemplateElement | null
}

export type SearchResultsPanel = ReturnType<typeof createSearchResultsPanel>

export function createSearchResultsPanel(elements: SearchResultsElements) {
  const resetState = () => {
    if (elements.loading) elements.loading.classList.add('hide')
    if (elements.error) elements.error.hidden = true
    if (elements.empty) elements.empty.hidden = true
  }

  return {
    reset() {
      resetState()
    },

    showLoading() {
      resetState()

      if (elements.loading) elements.loading.classList.remove('hide')
    },

    showResults(page: SearchPage) {
      if (!elements.list) return

      resetState()

      const rows = page.items.map(item => renderRow(item, { template: elements.rowTemplate ?? null }))

      elements.list.replaceChildren(...rows)

      if (elements.empty) elements.empty.hidden = page.items.length > 0
    },

    showError() {
      resetState()

      if (elements.error) elements.error.hidden = false
    }
  }
}
